import React from 'react';
import type { CategorySelectorProps } from './CategorySelector';
import type { CategorySelectorDropdownProps } from './CategorySelectorDropdown';

type DistributiveOmit<T, K extends keyof T> = T extends {} ? Omit<T, K> : never;

export type OldCategorySelectorProps = DistributiveOmit<CategorySelectorProps, 'onChange'> & {
  onSelectedKeysChange: CategorySelectorProps['onChange'];
};

export function convertOldCategorySelectorProps(props: OldCategorySelectorProps): CategorySelectorProps {
  const { onSelectedKeysChange, ...restProps } = props;

  return {
    ...restProps,
    onChange: onSelectedKeysChange,
  } as CategorySelectorProps;
}

export interface OldCategorySelectorDropdownProps<OptionValue>
  extends Omit<CategorySelectorDropdownProps<OptionValue>, 'onChange' | 'shouldCloseOnOutsideClick'> {
  /** @deprecated onChange를 대신 사용해주세요. */
  onOptionValuesChange?: (values: Array<OptionValue>) => void;
  /** @deprecated shouldCloseOnOutsideClick을 대신 사용해주세요. */
  canClickOutside?: boolean;
}

export function convertOldCategorySelectorDropdownProps<OptionValue>(
  props: OldCategorySelectorDropdownProps<OptionValue>,
): CategorySelectorDropdownProps<OptionValue> {
  const { children, onOptionValuesChange, canClickOutside, ...restProps } = props;
  const convertedChildren = React.isValidElement<OldCategorySelectorProps>(children)
    ? React.cloneElement(children, {
        onChange: children.props.onSelectedKeysChange,
      } as Partial<CategorySelectorProps>)
    : children;

  return {
    ...restProps,
    children: convertedChildren,
    onChange: onOptionValuesChange,
    shouldCloseOnOutsideClick: canClickOutside,
  };
}
